import React from 'react'
import { Button } from '@/components/ui/button'
import { Body2, Heading3 } from '@/components/ui/typography'
import { CreateIntroducingBrokerProfile } from 'api/Trading-Accounts/Types/CreateIntroducingBrokerProfile'
import { ErrorMessage, Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { useAppSelector } from 'store'
import styled from 'styled-components'
import { FormSubmitValues } from 'utils/formValidation'

const FormContainer = styled.div`
  margin: 2.5rem;
`

const FormFieldContainer = styled.div`
  display: flex;
  margin: 8px;
  width: 100%;
  label {
    width: 15%;
    font-weight: bold;
  }

  input,
  select {
    color: #0e76eb;
    border: none;
    width: 100%;
    transition: all 0.2s ease;
    background-color: transparent;
    font-size: 14px;
    outline: none;
    resize: none;
    overflow: hidden;
    text-align: left;
    border-bottom: 1px solid rgba(176, 180, 186, 0.42);
  }
`

const CreateIntroducingBrokerProfileFormUI: React.FC<
  FormikProps<IntroducingBrokerProfileFormValues> & OuterProps
> = (props) => {
  const { handleSubmit, validateForm } = props

  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return (
    <FormContainer>
      <Form
        onSubmit={handleSubmit}
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <Heading3 className='text-[#0e76eb] flex flex-row justify-center items-center'>
          Create Introducing Broker Profile
        </Heading3>
        <FormFieldContainer>
          <Body2 as='label' bold>
            Name
          </Body2>
          <Field type='text' name='name' />
          <ErrorMessage name='name' component='div' className='transaction__invalid-feedback' />
        </FormFieldContainer>
        <FormFieldContainer>
          <Body2 as='label' bold>
            Description
          </Body2>
          <Field type='text' name='description' />
        </FormFieldContainer>
        <FormFieldContainer>
          <Body2 as='label' bold>
            Tickmill Company
          </Body2>
          <Field component='select' name='tickmillCompanyId'>
            <option value={0}>None</option>
            {tickmillCompanies.map((x) => (
              <option key={x.id} value={x.id}>
                {x.name}
              </option>
            ))}
          </Field>
        </FormFieldContainer>
        <Button type='submit' onClick={() => validateForm()}>
          {'Submit'}
        </Button>
      </Form>
    </FormContainer>
  )
}

interface OuterProps {
  onSubmit(values: FormSubmitValues<IntroducingBrokerProfileFormValues>): Promise<void>
}

export type IntroducingBrokerProfileFormValues = CreateIntroducingBrokerProfile

export const CreateIntroducingBrokerProfileForm = withFormik<
  OuterProps,
  IntroducingBrokerProfileFormValues
>({
  mapPropsToValues: () => {
    return {
      description: '',
      name: '',
      tickmillCompanyId: '0',
    }
  },
  validate: (values) => {
    const errors: FormikErrors<IntroducingBrokerProfileFormValues> = {}
    if (!values.name) {
      errors.name = 'required'
    }
    if (!values.tickmillCompanyId) {
      errors.tickmillCompanyId = 'required'
    }
    return errors
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
})(CreateIntroducingBrokerProfileFormUI)
